var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spark-page"},[_c('div',{staticClass:"spark-page-title",domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('spark-html-block',{attrs:{"title":_vm.title,"content":_vm.content}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }